import links from "./links";

const messages = {
  oopsError: "Oops, it looks like something went wrong!",
  oopsErrorContent:
    "We apologize for the issue and our support team has been notified. Please try refreshing your page. If it still not working, please try again later.",
  errorMsg:
    " If you believe this is incorrect, please click <a href='" +
    links.contactUs +
    "' target='_blank'>Contact Us</a> to connect with P&A Group's Participant Support Center.",
  errorMsg2:
   " Please <a href='" + 
   links.contactUs +
   "' target=_'blank'>Contact Us</a> to connect with P&A Group's Participant Support Center.",
  notAllowedDocument:
    "One or more file(s) you are trying to upload does not meet the file types allowed. Please reference the list of permitted file types.",
  dependentNoDelete:
    "This dependent can't be removed. {dependent_first_name} {dependent_last_name} is enrolled in the following benefits {all_benefits}. If you still wish to remove {dependent_first_name}, go to the Benefits page and remove them from all benefits.",
  benefitRelationError:
    "You are unable to modify the relationship as your benefit doesn't allow for it.",
  autoLogoutMsg:
    "System has logged you out due to inactivity, please log in again.",
  dependentValMsg:
    "The required dependent for this option is not entered, please go to the Dependents page and enter the dependent.",
  dirtyFormCheckMsg:
    "You have unsaved changes. Are you sure you want to leave this page?",
};

export default messages;
